import * as React from "react";
import { BodyLarge, DisplayLarge } from "@conserveit/blocks";
import { Zone } from "context/reports/comfort/types";
import { roundDatum } from "../../../../utils/numbers";
import * as TT from "../../components/ChartToolTip";

type Category = "hot" | "cold" | "uncomfortable" | "comfortable";

interface Props {
  name: Zone["name"];
  categoryOccupiedHours?:
    | Zone["hoursCold"]
    | Zone["hoursHot"]
    | Zone["hoursComfort"]
    | Zone["hoursDiscomfort"];
  categoryOccupiedPct: Zone["pctComfort"] | Zone["pctDiscomfort"];
  totalOccupiedHours?: Zone["hoursOccupied"];
  category: Category;
  from?: string;
  to?: string;
  date?: string;
}

export const ToolTip: React.FC<Props> = ({
  name,
  categoryOccupiedHours,
  categoryOccupiedPct,
  totalOccupiedHours,
  category,
  from,
  to,
  date,
}) => (
  <TT.Container>
    <TT.TipHead>
      <TT.Left>{name}</TT.Left>
      <TT.Right>
        {from && to && (
          <span>
            {new Date(from).toLocaleString("default", { month: "short" })}{" "}
            {new Date(from).getFullYear()} -{" "}
            {new Date(to).toLocaleString("default", { month: "short" })}{" "}
            {new Date(to).getFullYear()}
          </span>
        )}
        {date && (
          <span>
            {new Date(date).toLocaleString("default", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </span>
        )}
      </TT.Right>
    </TT.TipHead>
    <TT.ValueLabel>{category}</TT.ValueLabel>
    <BodyLarge>
      <DisplayLarge as="span">
        {roundDatum(categoryOccupiedPct!)}
        {"%"}
      </DisplayLarge>{" "}
      of occupied hours
    </BodyLarge>
    {categoryOccupiedHours && totalOccupiedHours && (
      <BodyLarge>
        <DisplayLarge as="span">
          {roundDatum(categoryOccupiedHours)}
        </DisplayLarge>{" "}
        hours (of {roundDatum(totalOccupiedHours)})
      </BodyLarge>
    )}
  </TT.Container>
);
